<div class="voice-search">
  <div class="bar">
    <input
      type="text"
      [value]="query"
      placeholder="Rechercher un produit…"
      readonly
    />

    <!-- Bouton appui-maintenu : mouse + touch -->
    <button
      class="mic-btn"
      [class.listening]="isListening"
      (mousedown)="startRecording()"
      (mouseup)="stopRecording()"
      (mouseleave)="isListening && stopRecording()"
      (touchstart)="startRecording()"
      (touchend)="stopRecording()"
      (touchcancel)="stopRecording()"
      aria-label="Recherche vocale"
    >
      🎤
    </button>
  </div>

  <div class="hint" *ngIf="hint">{{ hint }}</div>
  <div class="error" *ngIf="errorMsg">{{ errorMsg }}</div>

  <ul class="results" *ngIf="results?.length">
    <li *ngFor="let p of results">
      {{ p.name || p.title || (p | json) }}
    </li>
  </ul>
</div>
